"use client";

import FlameIcon from "@repo/ui-system/icons/random/flame/outline.svg";

import { formatSeconds } from "./format-seconds";
import { toIsoDuration } from "./to-iso-duration";
import { useCountdown } from "./use-countdown";

const TWENTY_FOUR_HOURS_IN_SECONDS = 86_400;

export function LimitedTimeDealStrip({
  initialSeconds,
}: {
  initialSeconds: number;
}) {
  const showCountdown = initialSeconds <= TWENTY_FOUR_HOURS_IN_SECONDS;
  const seconds = useCountdown(initialSeconds, { enabled: showCountdown });

  return (
    <div className="inline-flex items-center gap-2 py-1 px-2 text-badge-timedeal-text">
      <FlameIcon
        className="size-4 shrink-0 -translate-y-px"
        aria-hidden="true"
      />
      <span className="mini1 text-text-grayscale-subtitle">
        Limited time deal
      </span>
      {showCountdown && (
        <time
          dateTime={toIsoDuration(seconds)}
          className="sub1"
          suppressHydrationWarning
        >
          {formatSeconds(seconds)}
        </time>
      )}
    </div>
  );
}
